import store from "@/store/index.js";
import fetchIntercept from "fetch-intercept";

export default class ConnectorService {
  constructor() {
    this.authIntercept = fetchIntercept.register({
      request: function (url, config) {
        config = {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + store.getters["auth/token"],
          },
        };
        return [url, config];
      },

      requestError: function (error) {
        // Called when an error occured during another 'request' interceptor call
        return Promise.reject(error);
      },

      response: async function (response) {
        // Modify the reponse object
        return response;
      },

      responseError: function (error) {
        // Handle an fetch error
        return Promise.reject(error);
      },
    });
  }

  unregister() {
    this.authIntercept();
  }

  async promptOtp(otp) {
    const response = await fetch(process.env.VUE_APP_OTP_ENDPOINT + otp);
    if (!response.ok) {
      const message = response.status;
      throw new Error(message);
    }
    const data = await response.json();
    store.dispatch("otp/updateId", data.sessionId);
    return response;
  }

  async getDataChannelCredentials() {
    const response = await fetch(
      process.env.VUE_APP_ABLY_ENDPOINT + store.getters["otp/sessionId"]
    );
    if (!response.ok) {
      const message = response.status;
      throw new Error(message);
    }
    const data = await response.json();
    store.dispatch("ably/establishDataChannel", {
      id: data.id,
      sessionId: store.getters["otp/sessionId"],
      token: store.getters["auth/token"],
    });
    return response;
  }

  async getVideoCredentials() {
    const response = await fetch(
      process.env.VUE_APP_VONAGE_ENDPOINT + store.getters["otp/sessionId"]
    );
    if (!response.ok) {
      const message = response.status;
      throw new Error(message);
    }
    const data = await response.json();
    await store.dispatch("avConnection/establishVideoConnection", data);
    return response;
  }
}
